import { Reducer } from 'redux';

import { LANDING_PAGE_ID_FOR_SETTING_ACCOUNT_SUBDOMAIN } from '@/services/constants';
import { ActionTypes, LandingPageSubdomain, LandingPageSubdomainSuccess } from './types';

const defaultState: LandingPageSubdomain = {
    loading: false,
    accountSubdomain: null,
    landingPageSubdomain: null,
};

/**
 *
 * funciton to update proper properties based on LandingPageID,
 * account subdomain is returned for LandingPageID = 0
 * other landing pages has LandingPageID > 0
 * @returns Parial<LandingPageSubdomain>
 */
const updateLandingPageOrAccountSubdomainBasedOnLandingPageId = (action: LandingPageSubdomainSuccess) => {
    const { subdomain } = action?.payload || {};
    const accountSubdomain =
        subdomain?.LandingPageID === LANDING_PAGE_ID_FOR_SETTING_ACCOUNT_SUBDOMAIN && subdomain?.UrlPrefix;
    if (accountSubdomain) {
        return { accountSubdomain };
    }
    return {
        landingPageSubdomain: subdomain,
    };
};

const reducer: Reducer<LandingPageSubdomain> = (
    state: LandingPageSubdomain = defaultState,
    action
): LandingPageSubdomain => {
    switch (action.type) {
        case ActionTypes.LANDING_PAGE_SUBDOMAIN_SUCCESS:
            return {
                ...state,
                loading: false,
                ...updateLandingPageOrAccountSubdomainBasedOnLandingPageId(action as LandingPageSubdomainSuccess),
            };

        case ActionTypes.LANDING_PAGE_SUBDOMAIN_ERROR:
        case ActionTypes.LANDING_PAGE_SKIP_SUBDOMAIN_LOADING:
            return {
                ...state,
                loading: false,
            };
        case ActionTypes.ADD_LANDING_PAGE_SUBDOMAIN:
        case ActionTypes.UPDATE_LANDING_PAGE_SUBDOMAIN:
        case ActionTypes.ADD_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN:
        case ActionTypes.UPDATE_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN:
        case ActionTypes.GET_LANDING_PAGE_SUBDOMAIN:
            return {
                ...state,
                loading: true,
            };
        default:
            return state;
    }
};

export { reducer as landingPageSubdomain };
